export default "__VITE_ASSET__62769390__"